import React from "react";

import Error404 from "../components/pages/errors/Error404";

const Error404Page = () => <Error404 />;
export default Error404Page;
